import { useState, useEffect } from 'react';
import { getHeadersUnwrapped, searchSerialNumbers, useUserContext } from '..';
import { compose as lcompose } from 'lodash/fp';

export const useSerialNumberSearch = () => {
  const { user } = useUserContext();

  const [serialNumberInput, setSerialNumberInput] = useState('');
  const [options, setOptions] = useState<string[]>([]);

  useEffect(() => {
    lcompose(
      searchSerialNumbers,
      getHeadersUnwrapped
    )(user)(serialNumberInput).then(setOptions);
  }, [serialNumberInput, user]);

  return { serialNumbers: options, serialNumberInput, setSerialNumberInput };
};
